import 'bootstrap/js/dist/tab';

let tabsNavItems = document.querySelectorAll('.custom-tabs .nav-item');
let tabsContentItems = document.querySelectorAll('.custom-tabs .tab-pane');

window.addEventListener("load", openTabByHash, false);
window.addEventListener("hashchange", openTabByHash, false);

function getCoords(elem) {
    let box = elem.getBoundingClientRect();

    return {
        top: box.top + pageYOffset,
        left: box.left + pageXOffset
    };
}

function openTabByHash() {
    if (tabsNavItems) {
        let url = location.href.replace(/\/$/, "");

        if (location.hash) {
            const hash = url.split('#');
            for (let item in tabsNavItems) {
                if(tabsNavItems[item].classList) {
                    tabsNavItems[item].classList.remove('active');
                }
            }
            for (let item in tabsContentItems) {
                if(tabsContentItems[item].classList) {
                    tabsContentItems[item].classList.remove('active');
                    tabsContentItems[item].classList.remove('show');
                }
            }

            document.querySelector('.custom-tabs a[href="#' + hash[1] + '"]').classList.add('active');
            document.querySelector('.custom-tabs #' + hash[1]).classList.add('active');
            document.querySelector('.custom-tabs #' + hash[1]).classList.add('show');
            url = location.href.replace(/\/#/, '#');
            history.replaceState(null, null, url);

            let coords = getCoords(document.querySelector('.custom-tabs'));

            window.scrollTo({
                top: (coords.top - 80), // 80 is a header height
                behavior: "smooth"
            });
        }

        for (let item in tabsNavItems) {
            if(tabsNavItems[item].classList) {
                tabsNavItems[item].onclick = function(){
                    let newUrl;
                    const hash = tabsNavItems[item].getAttribute("href");

                    if (hash == "#nav-details") {
                        newUrl = url.split("#")[0];
                    } else {
                        newUrl = url.split("#")[0] + hash;
                    }
                    history.replaceState(null, null, newUrl);
                };
            }
        }

    }
}



